import { useGetIdentity } from "@refinedev/core";
import {
  ActionIcon,
  Badge,
  Box,
  Group,
  Header as MantineHeader,
  Avatar,
  Text,
  Title,
  useMantineColorScheme,
} from "@mantine/core";
import { IconSun, IconMoonStars } from "@tabler/icons";

export const Header: React.FC = () => {
  const { data: user } = useGetIdentity<{ name?: string; avatar?: string }>();
  const showUserInfo = user && (user.name || user.avatar);

  const { colorScheme, toggleColorScheme } = useMantineColorScheme();
  const dark = colorScheme === "dark";

  return (
    <MantineHeader
      height={72}
      p="md"
      sx={(theme) => ({
        position: "sticky",
        top: 0,
        zIndex: 200,
        backdropFilter: "blur(18px)",
        backgroundColor:
          theme.colorScheme === "dark"
            ? "rgba(8, 17, 31, 0.72)"
            : "rgba(248, 251, 255, 0.8)",
        borderBottom: `1px solid ${
          theme.colorScheme === "dark"
            ? "rgba(255,255,255,0.08)"
            : "rgba(15,23,42,0.08)"
        }`,
      })}
    >
      <Group position="apart" sx={{ height: "100%" }}>
        <Box sx={{ minWidth: 0 }}>
          <Badge
            variant="light"
            color="violet"
            mb={6}
            sx={(theme) => ({
              [theme.fn.smallerThan("sm")]: {
                display: "none",
              },
            })}
          >
            Admin workspace
          </Badge>
          <Title order={3} sx={(theme) => ({
            [theme.fn.smallerThan("sm")]: {
              fontSize: theme.fontSizes.lg,
              lineHeight: 1.2,
            },
          })}>
            Ebixi control center
          </Title>
          <Text
            size="sm"
            color="dimmed"
            sx={(theme) => ({
              [theme.fn.smallerThan("sm")]: {
                display: "none",
              },
            })}
          >
            Monitor operations, wallets, transactions, and provider activity.
          </Text>
        </Box>

        <Group spacing="xs" noWrap>
        <ActionIcon
          variant="light"
          color={dark ? "yellow" : "primary"}
          onClick={() => toggleColorScheme()}
          title="Toggle color scheme"
          size="lg"
        >
          {dark ? <IconSun size={18} /> : <IconMoonStars size={18} />}
        </ActionIcon>
        {showUserInfo && (
          <Group
            spacing="xs"
            sx={(theme) => ({
              padding: "6px 8px 6px 12px",
              borderRadius: theme.radius.xl,
              backgroundColor:
                theme.colorScheme === "dark"
                  ? "rgba(255,255,255,0.05)"
                  : "rgba(255,255,255,0.85)",
              border: `1px solid ${
                theme.colorScheme === "dark"
                  ? "rgba(255,255,255,0.08)"
                  : "rgba(15,23,42,0.08)"
              }`,
              [theme.fn.smallerThan("sm")]: {
                display: "none",
              },
            })}
          >
            <Box sx={(theme) => ({
              textAlign: "right",
              [theme.fn.smallerThan("sm")]: {
                display: "none",
              },
            })}>
              <Text size="sm" weight={600}>
                {user?.name}
              </Text>
              <Text size="xs" color="dimmed">
                Signed in
              </Text>
            </Box>
            <Avatar src={user?.avatar} alt={user?.name} radius="xl" />
          </Group>
        )}
        </Group>
      </Group>
    </MantineHeader>
  );
};
